module.exports = __webpack_public_path__ + "public/img/昨日设备报警统计.f5ba19f1.png";